import { api } from '../main-api/apiClient';

export const SystemAdminPatientAPI = {
  // Get all patients with pagination and filtering
  getAllPatients: async (page = 1, pageSize = 10, search = '', tenantId = '', status = '') => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());
    
    if (search) params.append('search', search);
    if (tenantId) params.append('tenant_id', tenantId);
    if (status) params.append('status', status);
    
    const response = await api.get(`/system-admin/patients?${params.toString()}`);
    return response.data;
  },

  // Get patient by ID
  getPatientById: async (patientId) => {
    const response = await api.get(`/system-admin/patients/${patientId}`);
    return response.data;
  },

  // Create new patient
  createPatient: async (patientData) => {
    const response = await api.post('/system-admin/patients', patientData);
    return response.data;
  },

  // Update patient
  updatePatient: async (patientId, updateData) => {
    const response = await api.put(`/system-admin/patients/${patientId}`, updateData);
    return response.data;
  },

  // Delete patient
  deletePatient: async (patientId) => {
    const response = await api.delete(`/system-admin/patients/${patientId}`);
    return response.data;
  },

  // Get patient statistics
  getPatientStatistics: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/system-admin/patients/statistics?${params.toString()}`);
    return response.data;
  },

  // Get patient recordings
  getPatientRecordings: async (patientId, page = 1, pageSize = 10) => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());
    
    const response = await api.get(`/system-admin/patients/${patientId}/recordings?${params.toString()}`);
    return response.data;
  },

  // Get all tenants for patient filtering
  getAllTenants: async () => {
    const response = await api.get('/system-admin/tenants');
    return response.data;
  },

  // Get patient vitals
  getPatientVitals: async (patientId, page = 1, pageSize = 10) => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());
    
    const response = await api.get(`/system-admin/patients/${patientId}/vitals?${params.toString()}`);
    return response.data;
  },

  // Export patient data
  exportPatientData: async (patientId, format = 'json') => {
    const response = await api.get(`/system-admin/patients/${patientId}/export?format=${format}`);
    return response.data;
  },

  // Bulk operations
  bulkUpdatePatients: async (patientIds, updateData) => {
    const response = await api.put('/system-admin/patients/bulk-update', {
      patient_ids: patientIds,
      update_data: updateData
    });
    return response.data;
  },

  bulkDeletePatients: async (patientIds) => {
    const response = await api.delete('/system-admin/patients/bulk-delete', {
      data: { patient_ids: patientIds }
    });
    return response.data;
  }
};